import { render, staticRenderFns } from "./ReportNumber.vue?vue&type=template&id=053900b4&"
import script from "./ReportNumber.vue?vue&type=script&lang=js&"
export * from "./ReportNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports